import { AppConfig, HeadersKeys, PRODUCTION_ENVIROMENTS } from '@/types/Config'

const config = new AppConfig()

config.enviroment = process.env.VUE_APP_ENVIRONMENT || ''
config.isProduction = PRODUCTION_ENVIROMENTS.includes(process.env.NODE_ENV || '')
config.activeLogs = Number(process.env.VUE_APP_ACTIVE_LOGS) === 1

config.apiPlatformUrl = process.env.VUE_APP_CONFIG_API_PLATFORM_URL || ''
config.apiUsersUrl = `${process.env.VUE_APP_CONFIG_API_USERS_URL || process.env.VUE_APP_CONFIG_API_URL}rest/`
config.apiFillsUrl = `${process.env.VUE_APP_CONFIG_API_FILLS_URL || process.env.VUE_APP_CONFIG_API_URL}rest/`
config.apiReportsUrl = `${process.env.VUE_APP_CONFIG_API_REPORTS_URL || process.env.VUE_APP_CONFIG_API_URL}reports/`
config.basePath = process.env.VUE_APP_DEPLOY_PUBLIC_PATH || ''
config.appDomain = process.env.VUE_APP_CONFIG_APP_DOMAIN || ''
config.jwtAccessTokenCookieName = process.env.VUE_APP_CONFIG_JWT_ACCESS_TOKEN_COOKIE_NAME || ''
config.refreshTokenCookieName = process.env.VUE_APP_CONFIG_JWT_REFRESH_TOKEN_COOKIE_NAME || ''
config.projectIdCookieName = process.env.VUE_APP_CONFIG_PROJECT_ID_COOKIE_NAME || ''
config.domainIdCookieName = process.env.VUE_APP_CONFIG_DOMAIN_ID_COOKIE_NAME || ''
config.domainUIDCookieName = process.env.VUE_APP_CONFIG_DOMAIN_UID_COOKIE_NAME || ''
// Setting Headers
config.headers.jwtRefreshToken = process.env.VUE_APP_CONFIG_JWT_REFRESH_TOKEN_HEADER || HeadersKeys.JWT_REFRESH_TOKEN

config.firebase.appId = process.env.VUE_APP_FIREBASE_APP_ID || ''
config.firebase.apiKey = process.env.VUE_APP_FIREBASE_API_KEY || ''
config.firebase.authDomain = process.env.VUE_APP_FIREBASE_AUTH_DOMAIN || ''
config.firebase.databaseURL = process.env.VUE_APP_FIREBASE_DB_URL || ''
config.firebase.projectId = process.env.VUE_APP_FIREBASE_PROJECT_ID || ''
config.firebase.storageBucket = process.env.VUE_APP_FIREBASE_STORAGE_ID || ''
config.firebase.messagingSenderId = process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID || ''

config.googleMaps.apiKey = process.env.VUE_APP_GOOGLE_MAPS_API_KEY || ''
config.googleMaps.snapUrl = process.env.VUE_APP_GOOGLE_MAPS_SNAP_URL || ''

config.mapbox.accessToken = process.env.VUE_APP_MAPBOX_ACCESS_TOKEN || ''
config.mapbox.directionsUrl = process.env.VUE_APP_MAPBOX_DIRECTIONS_URL || ''

config.tracking.snapToRoadsPageRequestSize = Number(process.env.VUE_APP_TRACKING_SNAP_TO_ROADS_PAGE_REQUEST_SIZE) || 100

config.awsS3.bucketName = process.env.VUE_APP_AWS_BUCKET_NAME || ''
config.awsS3.awsAccessKeyId = process.env.VUE_APP_AWS_ACCESS_KEY_ID || ''
config.awsS3.awsSecretAccessKey = process.env.VUE_APP_AWS_SECRET_ACCESS_KEY || ''
config.awsS3.errorsTranslateFile = process.env.VUE_APP_ERRORS_TRANSLATE_FILE || ''
config.awsS3.awsS3Region = process.env.VUE_APP_S3_REGION || ''

export default config
